/**
 * Full-scope received-payments cache helpers.
 * GET /api/payments has no payment-date / schoolYear query filters, so year tabs
 * need the full filtered list. Cache it in Redux so leaving Payments does not
 * re-download every historical page.
 */
export const PAYMENTS_SCOPE_FRESH_MS = 3 * 60 * 1000

export type PaymentsScopeKeyParams = {
  search?: string
  guestPayerName?: string
  classroom?: string
  paymentMonth?: string
  ticketNumberSearch?: string
  users?: string[]
  role?: string
  sortField?: string
  sortOrder?: string
  startDate?: string
  endDate?: string
}

export function serializePaymentsScopeKey(params: PaymentsScopeKeyParams): string {
  const users = [...(params.users || [])].map((id) => String(id).trim()).filter(Boolean).sort()
  return JSON.stringify({
    paymentType: 'received',
    search: params.search?.trim() || '',
    guestPayerName: params.guestPayerName?.trim() || '',
    classroom: params.classroom || '',
    paymentMonth: params.paymentMonth || '',
    ticketNumberSearch: params.ticketNumberSearch?.trim() || '',
    users,
    role: params.role || '',
    sortField: params.sortField || 'createdAt',
    sortOrder: params.sortOrder || 'desc',
    startDate: params.startDate || '',
    endDate: params.endDate || '',
  })
}

export function isPaymentsScopeFresh(
  loadedAt: number | null | undefined,
  now = Date.now(),
  freshMs = PAYMENTS_SCOPE_FRESH_MS
): boolean {
  return loadedAt != null && now - loadedAt < freshMs
}

export function shouldSkipPaymentsScopeFetch(args: {
  requestedKey: string
  cacheKey: string | null
  loadedAt: number | null
  loading: boolean
  inFlightKey: string | null
  stale: boolean
  force?: boolean
}): boolean {
  if (args.loading && args.inFlightKey === args.requestedKey) return true
  if (args.force || args.stale) return false
  return args.cacheKey === args.requestedKey && isPaymentsScopeFresh(args.loadedAt)
}
